import { ReversionRequestComponent } from './../pages/reversions/reversion-request/reversion-request.component';
export const moduleRoutes = {
  root: 'search',
  childForms: {
    transactionStore: {
      data: { title: 'Transacciones' },
      requireAuth: true,
      functions: [],
      route: 'transactionStore',
    },
    transactionsReport: {
      data: { title: 'Transacciones' },
      requireAuth: true,
      functions: [],
      route: 'transactionsReport',
    },
    reversionRequests: {
      data: { title: 'Transacciones' },
      requireAuth: true,
      functions: [],
      route: 'reversions',
    },
    reversionApproved: {
      data: { title: 'Transacciones' },
      requireAuth: true,
      functions: [],
      route: 'reversions-approved',
    },
    reversionRejected: {
      data: { title: 'Transacciones' },
      requireAuth: true,
      functions: [],
      route: 'reversions-rejected',
    },
  },
  layout: 'main',
  loadChildren: () => import('src/app/pages/transactions/search-query/search-query.module').then(m => m.TxnSearchQueryModule),
};
